import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { Button, Link, Stack, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { Edit } from '@mui/icons-material';
import { isLinksJson, isOldLinksJson } from '../../../../../form/links/LinksFormInput';
import { useTheme } from '@mui/material/styles';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

export const LinksCell: FC<WidgetProps> = ({ activityId, activityName, widget: { links } }) => {
	const intl = useIntl();
	const theme = useTheme();
	const [isEditMode, setIsEditMode] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const { setDrawerWithoutPrevParams } = useDrawerContext();

	const storedLinks = (() => {
		if (isLinksJson(links)) {
			return links.values;
		} else if (isOldLinksJson(links)) {
			return links.values.map((link) => ({ link, text: undefined }));
		}
		return null;
	})();

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.links.type}
			editMode={isEditMode}
			showEditOnHover
			tooltipText={intl.formatMessage({ id: 'journey.detail.widget.edit' })}
			handleEditAction={() => {
				setDrawerWithoutPrevParams('editLinks', { activityId }, () => setIsEditMode(false));
				setIsEditMode(true);
			}}
			onMouseEnter={() => setShowEdit(true)}
			onMouseLeave={() => setShowEdit(false)}
		>
			{showEdit && (
				<Tooltip title={intl.formatMessage({ id: 'journey.detail.widget.edit' })}>
					<Button
						size={'small'}
						variant={'outlined'}
						color={'secondary'}
						sx={{
							aspectRatio: '1/1',
							minWidth: 0,
							top: '10px',
							right: '10px',
							position: 'absolute',
							padding: 0,
							width: '24px',
							height: '24px',
						}}
						onClick={() => {
							setDrawerWithoutPrevParams('editLinks', { activityId }, () => setIsEditMode(false));
							setIsEditMode(true);
						}}
					>
						<Edit sx={{ width: '16px', height: '16px' }} />
					</Button>
				</Tooltip>
			)}
			<Stack direction={'column'}>
				{storedLinks?.map(({ link, text }) => {
					const linkWithoutWww = link.replace(/^www\./, '');

					return (
						link && (
							<Link
								key={link}
								href={`https://${link}`}
								target={'_blank'}
								rel={'noreferrer'}
								color={theme.palette.grey[700]}
								sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
							>
								{text || linkWithoutWww}
							</Link>
						)
					);
				})}
			</Stack>
		</WidgetCell>
	);
};
